import { WidgetConfigType, WidgetType } from "./widgetConfig";

type SelectionRangeValidationParams = {
    selectedCount: number;
    minItems?: number;
    maxItems?: number;
    enforceMin?: boolean;
    enforceMax?: boolean;
};

export const hasSensorAndActuator = (attributes: any[] = []) => {
    const hasSensor = attributes.some((attr: any) => attr?.isActuator === false);
    const hasActuator = attributes.some((attr: any) => attr?.isActuator === true);

    return hasSensor && hasActuator;
};

type CreateValidationParams = {
    createData: any;
    widgetType?: WidgetType;
    widgetConfig?: WidgetConfigType;
    isPSLWidgetSource: boolean;
};

type UpdateValidationParams = {
    panel: any;
    widgetType?: WidgetType | null;
    widgetConfig?: WidgetConfigType;
};

export const isOutOfSelectionRange = ({
    selectedCount,
    minItems,
    maxItems,
    enforceMin = true,
    enforceMax = false,
}: SelectionRangeValidationParams) => {
    if (enforceMin && minItems !== undefined && selectedCount < minItems) {
        return true;
    }

    if (enforceMax && maxItems !== undefined && selectedCount > maxItems) {
        return true;
    }

    return false;
};

export const isCreateSubmitInvalid = ({
    createData,
    widgetType,
    widgetConfig,
    isPSLWidgetSource,
}: CreateValidationParams) => {
    const minItems = widgetConfig?.minItems ?? 1;
    const maxItems = widgetConfig?.maxItems ?? Infinity;
    const isCombined = widgetConfig?.isCombined ?? false;
    const isCorrelationWidget =
        widgetType === WidgetType.ACTUATOR_CHART_CORRELATION;
    const chartData = createData?.data?.[0];
    let selectedCount = 0;

    if (isCorrelationWidget) {
        const hasInvalidCorrelationSelection = (createData?.data || []).some(
            (item: any) =>
            (!hasSensorAndActuator(item?.attributes || []) ||
                (item?.attributes || []).length < minItems)
        );

        if (hasInvalidCorrelationSelection) {
            return true;
        }
    }

    if (widgetType === WidgetType.SENSOR_CHART_MULTIPLE || widgetType === WidgetType.ACTUATOR_CHART_MULTIPLE) {
        const hasInvalidMultipleSelection = (createData?.data || []).some(
            (item: any) => (item?.attributes || []).length < minItems
        );

        return hasInvalidMultipleSelection;
    }

    // For normal widget, data format is createData.data[0].attributes
    // For bulk create widget, data format is createData.data. e.g. createData.data[0] is one widget, createData.data[1] is another widget

    if (chartData?.attributes === undefined) {
        if (isPSLWidgetSource) {
            selectedCount = (createData?.data || []).filter(
                (item: any) => !!item.deviceId || !!item.ldsuUID
            ).length;
        } else {
            selectedCount = (createData?.data?.[0]?.attributes || createData?.data || []).filter((attr: any) => !!attr.deviceId).length;
        }
    } else if (isPSLWidgetSource) {
        selectedCount = (chartData.attributes || []).filter(
            (attr: any) => !!attr.deviceId || !!attr.ldsuUID
        ).length;
    } else {
        selectedCount = (createData?.data?.[0]?.attributes || createData?.data || []).filter((attr: any) => !!attr.deviceId).length;
    }

    return isOutOfSelectionRange({
        selectedCount,
        minItems,
        maxItems,
        enforceMin: true,
        enforceMax: isCombined,
    });
};

export const isUpdateSubmitInvalid = ({
    panel,
    widgetType,
    widgetConfig,
}: UpdateValidationParams) => {
    const minItems = widgetConfig?.minItems ?? 1;
    const maxItems = widgetConfig?.maxItems;
    const isCombinedWidget = widgetConfig?.isCombined ?? false;
    const isCorrelationWidget =
        widgetType === WidgetType.ACTUATOR_CHART_CORRELATION;

    if (isCorrelationWidget && !hasSensorAndActuator(panel?.attributes || [])) {
        return true;
    }

    const attributeCount = (panel?.attributes || []).filter((attr: any) => !!attr.deviceId || !!attr.gateway_id).length;

    return isOutOfSelectionRange({
        selectedCount: attributeCount,
        minItems,
        maxItems,
        enforceMin: true,
        enforceMax: isCombinedWidget,
    });
};

